import { connect } from 'react-redux';
import { getVerificationEmailAddress, getVerificationLoadingState, } from '../publicSession/selectors';
import { openUserDropdown } from '../SiteHeader/redux/actions';
import { resendVerificationEmail } from '../publicSession/actions';
import { dropFirstTimeFlag } from '../redux/firstTimeFlags/actions';
var mapStateToProps = function (state) {
    var _a;
    return ({
        email: getVerificationEmailAddress(state),
        isSendingDone: (_a = getVerificationLoadingState(state)) === null || _a === void 0 ? void 0 : _a.isSendingDone,
    });
};
var mapDispatchToProps = {
    changeEmail: openUserDropdown,
    resendEmail: resendVerificationEmail,
    dropFirstTimeFlag: dropFirstTimeFlag,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=VerificationPopup.container.js.map